<template>
  <q-select
    ref="select"
    :value="value"
    :options="mutableOptions"
    :tabindex="tabindex"
    :input-debounce="inputDebounce"
    use-input
    hide-selected
    fill-input
    hide-dropdown-icon
    :behavior="behavior"
    :autofocus="autofocus"
    :color="color"
    :bg-color="bgColor"
    :input-style="inputStyle"
    :error="error"
    :error-message="errorMessage"
    @filter="filterFn"
    v-on="$listeners">

    <template #no-option>
      <slot name="no-option">
        <q-item>
          <q-item-section class="text-grey">
            {{ noResultsText }}
          </q-item-section>
        </q-item>
      </slot>
    </template>

    <template v-slot:option="scope">
      <slot name="option" v-bind="scope">
        <r-custom-select-option :scope="scope"/>
      </slot>
    </template>

  </q-select>
</template>

<script>

import RCustomSelectOption from '@/components/base/RCustomSelectOption';

export default {
  name: 'RAutocomplete',
  components: { RCustomSelectOption },
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: Object,
    tabindex: Number,
    noResultsText: String,
    autofocus: Boolean,
    behavior: {
      type: String,
      validator: value => ['default', 'menu', 'dialog'].includes(value),
    },
    error: Boolean,
    errorMessage: String,
    color: String,
    bgColor: String,
    inputStyle: [String, Object],
    inputDebounce: Number,
    filterDebounce: Number, // Min number of characters before applying filter
  },
  data() {
    return {
      mutableOptions: this.options,
    };
  },
  methods: {
    filterFn(val, update, abort) {
      if (val.length < this.filterDebounce) {
        abort();
        return;
      }

      update(() => {
        const needle = val.toLocaleLowerCase();
        this.mutableOptions = this.options.filter(
          v => v.label.toLocaleLowerCase().indexOf(needle) > -1,
        );
      });
    },
    focus() {
      this.$refs.select.focus();
    },
  },
};
</script>
